/**
 * Single relay device template
 * Used by: SPSW-001PE16EU
 */

import {
	createTurnAction,
	createStateCondition,
	createStateChangedTrigger,
} from '../../common/stateManagement.js';
import { createPowerLevelCondition, createPowerThresholdTrigger } from '../../common/powerMonitoring.js';

export function createSingleRelayTemplate() {
	return {
		deviceType: 'single_relay',
		channels: ['switch:0'],
		actions: {
			turn: createTurnAction('Switch.Set', 'on'),
		},
		conditions: {
			isOn: createStateCondition('output'),
			powerLevel: createPowerLevelCondition(3680),
		},
		triggers: {
			stateChanged: createStateChangedTrigger('output'),
			powerThreshold: createPowerThresholdTrigger(3680),
		},
	};
}
